import { mapMemberStatusFromDTO } from '@/modules/common/mappers/member-status.mapper';

import { MemberAccessRow } from '../types/member-access';
import { UpdateMemberUserGroupItem } from '../types/request/member-access-request';
import { TeamMemberUserGroupResponse } from '../types/response/member-access-response';

/**
 * Maps API response to domain model for member access table row
 * Handles nullable group assignment
 * Converts groupId from number to string for SingleSelect compatibility
 */
export const mapMemberAccessFromResponse = (
  response: TeamMemberUserGroupResponse
): MemberAccessRow => {
  return {
    userId: response.user.id,
    name: response.user.name,
    email: response.user.email,
    profileImageUrl: response.user.profileImageUrl,
    groupId: response.group?.id != null ? response.group.id.toString() : null,
    groupName: response.group?.name ?? null,
    status: mapMemberStatusFromDTO(response.status),
  };
};

/**
 * Maps array of API responses to domain models
 */
export const mapMemberAccessListFromResponse = (
  responses: TeamMemberUserGroupResponse[]
): MemberAccessRow[] => {
  return responses.map(mapMemberAccessFromResponse);
};

/**
 * Maps member access rows to update request items
 * Only includes rows that have changed from initial state and have a valid groupId
 * Converts groupId from string back to number for API request
 */
export const mapMemberAccessToUpdateRequest = (
  currentMembers: MemberAccessRow[],
  initialMembers: MemberAccessRow[]
): UpdateMemberUserGroupItem[] => {
  const updates: UpdateMemberUserGroupItem[] = [];

  currentMembers.forEach(currentMember => {
    const initialMember = initialMembers.find(m => m.userId === currentMember.userId);

    // Only include if group has changed and the new groupId is not null
    if (
      initialMember &&
      initialMember.groupId !== currentMember.groupId &&
      currentMember.groupId !== null
    ) {
      updates.push({
        teamMemberId: currentMember.userId,
        userGroupId: Number(currentMember.groupId),
      });
    }
  });

  return updates;
};
